(function(angular) {
    'use strict';

        var inject = ['$scope', '$element', '$http', 'splitterGroupNotification', '$bentoBusyLoader', '$log', 'bmnNoteService', '$stateParams','$rootScope'];
        var documentPreviewCommentCtrl = function($scope:any, $element:any, $http:any, splitterGroupNotification:any, $bentoBusyLoader:any, $log:any, noteService:any, $stateParams:any, $rootScope:any) {
        loadNotes();

        /*** Open and close panels ***/
        $rootScope.notifySplitterGroup = function(action:any, splitterGroupID:any) {
            splitterGroupNotification.notify(action, splitterGroupID);
        };

        // For Splitter Group event tracking
        $scope.trackEvent = function(eventName:any) {
            $log.log('Splitter Group Event: ' + eventName);
        };

        function noteAlert(data:any) {
            $scope.alerts.push({
                type: data.Type,
                msg: data.Message,
                timeout: data.Timeout,
                closeable: true
            });
        }

        //load the notes and show the busy loader while its working
        function loadNotes(){
            $scope.isLoaderBusy = true;
            noteService.getNotes($stateParams.fileId).then(function(requestResult:any) {
                $scope.isLoaderBusy = false;
                if (requestResult.result === 'success') {
                    $scope.notes = requestResult.data;

                } else {
                    noteAlert({
                        Type: 'danger',
                        Message: 'The notes failed to load',
                        Timeout: 2500
                    });
                }

                $scope.$on('enteringEditMode', function(event:any, note:any) {
                    //broadcast this event to the new note directive, so that it will disable its buttons
                    $scope.noteToEdit = note;
                    $scope.$broadcast('parentEnteringEditMode', note);
                    $scope.isInEditMode = true;
                });

                $scope.$on('enteringAddMode', function() {
                    //broadcast this event to the existing notes so that they know to hide their edit buttons
                    $scope.$broadcast('parentEnteringAddMode', null);
                    $scope.isInAddMode = true;
                });

                $scope.$on('leavingAddMode', function() {
                    //broadcast this event to the existing notes so that they know to show their edit buttons
                    $scope.$broadcast('parentLeavingAddMode', null);
                    $scope.isInAddMode = false;
                });

                $scope.$on('enteringEditMode', function(event:any, note:any) {
                    //broadcast this event to the new note directive, so that it will disable its buttons
                    $scope.noteToEdit = note;
                    $scope.$broadcast('parentEnteringEditMode', note);
                    $scope.isInEditMode = true;
                });

                //something told us to turn on the busy loader
                $scope.$on('turnOnBusyLoader', function() {
                    $scope.isLoaderBusy = true;
                });

                //something told us to turn off the busy loader
                $scope.$on('turnOffBusyLoader', function() {
                    $scope.isLoaderBusy = false;
                });

                $scope.$on('leavingEditMode', function(event:any, note:any) {
                    //broadcast this event to the new note directive, so that it will enable its buttons
                    leaveEditMode(note);
                });

                //update our scope because a child was updated
                $scope.update = function(note:any) {
                    if (note !== null) {
                        for (var i = 0; i < $scope.notes.length; i++) {
                            if ($scope.notes[i].id === note.id) {
                                $scope.notes[i] = note;
                            }
                        }
                        leaveEditMode();
                    }
                };

                //notification from the existing-comment controller, telling us to remove a note
                $scope.unlistenBmnNoteDeleted = $rootScope.$on('bmnNoteDeleted', function(event:any, note:any) {
                    var index = $scope.notes.indexOf(note);
                    if (index > -1) {
                        $scope.notes.splice(index, 1);
                    }
                    leaveEditMode(note);
                });

                //notification from the new-note controller, telling us to add a note
                $scope.unlistenBmnNoteAdded = $rootScope.$on('bmnNoteAdded', function(event:any, note:any) {
                    $scope.notes.push(note);
                });

                //Logic to handle leaving edit mode
                //clear the note to edit object
                //and notify the new note directive
                function leaveEditMode(note?: any) {
                    $scope.noteToEdit = {};
                    $scope.$broadcast('parentLeavingEditMode', note);
                    $scope.isInEditMode = false;
                }

            });
        }

    };

    documentPreviewCommentCtrl.$inject = inject;

    angular.module('bluemoon.dms.viewer')
        .controller('documentPreviewCommentCtrl', documentPreviewCommentCtrl);

})((window as any).angular);
